import Styled from 'styled-components'
import Media from 'styled-media-query'

export default Styled.div`
  position: relative;
  display: inline-flex;
  align-self: center;
  max-width: calc(100% - 4rem);
  max-height: calc(100% - 4rem);

  ${Media.greaterThan('medium')`
    max-width: calc(100% - 6rem);
    max-height: calc(100% - 6rem);
  `}
`



// WEBPACK FOOTER //
// ./src/components/DialogContainer/index.js